module.exports = __webpack_public_path__ + "img/pic2.719fc1ab.png";